import * as Yup from "yup";

import { phoneLocalOnlyMessage } from "./messages";

export default function () {
    const regex = /^(?:(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))?$/s
    return Yup.string()
        .nullable()
        .matches(regex, phoneLocalOnlyMessage);

}
